import { FormGroupProps } from '@mui/material/FormGroup';
import { MuiFormGroup } from '../../../../../modules/material';
import FormFieldWrapper, { FormFieldWrapperProps } from '../FormFieldWrapper';

export interface CheckboxGroupProps
  extends Omit<FormFieldWrapperProps, 'testId'>,
    Pick<FormGroupProps, 'row'> {}

export default function CheckboxGroup(props: CheckboxGroupProps) {
  const { row, children, ...formFieldWrapperProps } = props;

  return (
    <FormFieldWrapper {...formFieldWrapperProps} testId="checkbox-group">
      <MuiFormGroup row={row}>{children}</MuiFormGroup>
    </FormFieldWrapper>
  );
}
